import { render, staticRenderFns } from "./rightInformation.vue?vue&type=template&id=c383b884"
import script from "./rightInformation.vue?vue&type=script&lang=js"
export * from "./rightInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports